<app-template>

    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf="isMobile === false  && isTablet === false">
        <div class="login-container">

            <!-- PASS MODIFICADO -->
            <div class="container max-width" *ngIf="!changePass && recoveryPassword === false">
                <div class="header">
                    <img src="assets/images/fad_personal_login.png" alt="Header Login">
                    <h1>
                        <p class="text">Iniciar Sesión</p>
                    </h1>
                </div>
                <div class="form">
                    <form [formGroup]="form">
                        <label for="cc-num" style="visibility: hidden;">credit card HubspotCollectedFormsWorkaround https://community.hubspot.com/t5/APIs-Integrations/How-to-stop-collected-forms-from-collecting-a-form/m-p/299172#M28102</label>
                        <input name="cc-num" style="visibility: hidden;" required="" value="HubspotCollectedFormsWorkaround" id="cc-num">
                        <mat-form-field appearance="outline">
                            <mat-label>Correo electrónico</mat-label>
                            <input appToLowercase formControlName="email" type="text" matInput required
                                   autocomplete="off">
                            <mat-error *ngIf="form.controls.email.hasError('required')">Campo requerido</mat-error>
                            <mat-error
                                    *ngIf="!form.controls.email.hasError('required') && form.controls.email.hasError('emailFormat')">
                                Correo
                                inválido
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Contraseña</mat-label>
                            <input formControlName="password" [type]="hide ? 'password' : 'text'" matInput required
                                   autocomplete="off">
                            <mat-icon matSuffix
                                      (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error>Campo requerido</mat-error>
                        </mat-form-field>
                        <div class="forgot">
                            <p (click)="recoveryPassword = true">Olvidé mi contraseña ></p>
                        </div>
                        <div class="actions">
                            <button id="inicar_sesion" [disabled]="form.invalid" class="submit-button"
                                    [ngClass]="{'disabled':form.invalid}" (click)="login()">
                                <p>INICIAR SESIÓN</p>
                            </button>
                        </div>
                        <div class="no-account">
                            <p (click)="createAccount()">¿No tienes cuenta?<br><span>Crea tu cuenta aquí</span></p>
                        </div>
                    </form>
                </div>
            </div>

            <!-- PASS RECUPERAR -->
            <div class="container max-width" *ngIf="recoveryPassword === true">
                <div class="header">
                    <img src="assets/images/fad_personal_login.png" alt="Header Login">
                    <p class="text" style="margin-top: 20px">Recuperar<br>Contraseña</p>
                </div>
                <div class="form">
                    <form [formGroup]="formRecovery">
                        <div class="no-account" style="margin: 0 0 20px;">
                            <div class="text"><strong>Ingresa el correo electrónico con el que ingresas al
                                portal.</strong></div>
                        </div>
                        <mat-form-field>
                            <input appToLowercase placeholder="Correo electrónico" formControlName="email" type="text"
                                   matInput>
                            <mat-error *ngIf="formRecovery.controls.email.hasError('required')">Campo requerido
                            </mat-error>
                            <mat-error
                                    *ngIf="!formRecovery.controls.email.hasError('required') && formRecovery.controls.email.hasError('emailFormat')">
                                Correo inválido
                            </mat-error>
                        </mat-form-field>
                        <div class="actions">
                            <re-captcha *ngIf="formRecovery.valid" (resolved)="resolved($event)"
                                        (error)="onError($event)"></re-captcha>
                        </div>
                        <div class="no-account">
                            <div class="text" *ngIf="formRecovery.invalid"><span>Si no recuerdas tu correo electrónico es necesario que te comuniques con tu administrador.</span>
                            </div>
                            <br>
                            <p>
                                <button *ngIf="formRecovery.valid && captcha" mat-raised-button
                                        (click)="recoveryPass()"><span>Recuperar</span>
                                </button>
                            </p>
                            <p (click)="recoveryPassword = false"><span>< Regresar</span></p>
                        </div>
                    </form>
                </div>
            </div>

            <!-- PASS RECUPERADO -->
            <div class="container max-width" *ngIf="changePass">
                <div class="header">
                    <img src="assets/images/fad_personal_login.png" alt="Header Login">
                    <p class="text" style="margin-top: 20px">Cambia tu<br>contraseña</p>
                </div>
                <div class="form">
                    <form [formGroup]="formPass">
                        <div class="no-account" style="margin: 0 0 20px; cursor:none;">
                            <p><strong>Reglas:</strong><br>
                                13 caracteres mínimo<br>
                                Utiliza por lo menos una mayúscula<br>
                                Utiliza por lo menos un número<br>
                                Utiliza por lo menos un caracter especial</p>
                        </div>
                        <mat-form-field appearance="outline">
                            <mat-label>Nueva contraseña</mat-label>
                            <input formControlName="passNew" [type]="hide ? 'password' : 'text'"
                                   matInput required autocomplete="off">
                            <mat-icon matSuffix
                                      (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="formPass.controls.passNew.hasError('required')">Campo requerido
                            </mat-error>
                            <mat-error
                                    *ngIf="!formPass.controls.passNew.hasError('required') && formPass.controls.passNew.hasError('passFormat')">
                                Tu contraseña no cumple los requisitos mínimos.
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Repite tu nueva contraseña</mat-label>
                            <input formControlName="passRepit" [type]="hide ? 'password' : 'text'" matInput required
                                   autocomplete="off">
                            <mat-icon matSuffix
                                      (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="formPass.controls.passRepit.hasError('required')">Campo requerido
                            </mat-error>
                            <mat-error
                                    *ngIf="!formPass.controls.passRepit.hasError('required') && formPass.controls.passRepit.hasError('passFormat')">
                                Tu contraseña no cumple los requisitos mínimos.
                            </mat-error>
                        </mat-form-field>
                        <mat-error *ngIf="checarSiSonIguales()">
                            Las contraseñas no son iguales.
                        </mat-error>
                        <div class="actions">
                            <button [disabled]="formPass.invalid" [ngClass]="{'disabled':formPass.invalid}"
                                    class="submit-button" (click)="changePassword()">
                                <p>GUARDAR</p>
                            </button>
                        </div>
                        <div class="no-account">
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">
        <div class="box-container">
            <div class="box-img">
                <img alt="Principal" class="img-prin" src="assets/images/m/telefonos.png">
            </div>

            <!-- PASS NO RECUPERADO-->
            <div class="content-res" *ngIf="!changePass && recoveryPassword === false">
                <h1>Iniciar sesión</h1>
            </div>

            <div class="box-light-fondo" *ngIf="!changePass && recoveryPassword === false">
                <div class="wrapper">
                    <form [formGroup]="form">
                        <label for="cc-num" style="visibility: hidden;">credit card HubspotCollectedFormsWorkaround https://community.hubspot.com/t5/APIs-Integrations/How-to-stop-collected-forms-from-collecting-a-form/m-p/299172#M28102</label>
                        <input name="cc-num" style="visibility: hidden;" required="" value="HubspotCollectedFormsWorkaround" id="cc-num1">
                        <mat-form-field appearance="outline">
                            <mat-label>Correo electrónico</mat-label>
                            <input appToLowercase formControlName="email" type="text" matInput required
                                   autocomplete="off">
                            <mat-error *ngIf="form.controls.email.hasError('required')">Campo requerido</mat-error>
                            <mat-error
                                    *ngIf="!form.controls.email.hasError('required') && form.controls.email.hasError('emailFormat')">
                                Correo
                                inválido
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Contraseña</mat-label>
                            <input formControlName="password" [type]="hide ? 'password' : 'text'" matInput required
                                   autocomplete="off">
                            <mat-icon matSuffix
                                      (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error>Campo requerido</mat-error>
                        </mat-form-field>
                        <div class="forgot">
                            <p (click)="recoveryPassword = true">Olvidé mi contraseña</p>
                        </div>
                        <div class="actions">
                            <button id="inicar_sesion_movil" class="submit-button" [disabled]="form.invalid"
                                    [ngClass]="{'disabled':form.invalid}" (click)="login()">
                                <p>INICIAR SESIÓN</p>
                            </button>
                        </div>
                        <div class="no-account">
                            <p (click)="createAccount()">¿No tienes cuenta?<br><span>Crea tu cuenta aquí</span></p>
                        </div>
                    </form>
                </div>
            </div>

            <!-- PASS RECUPERAR -->
            <div class="content-res" *ngIf="recoveryPassword === true">
                <h1>Recuperar contraseña</h1>
            </div>

            <div class="box-light-fondo" *ngIf="recoveryPassword === true">
                <div class="wrapper">
                    <form [formGroup]="formRecovery">
                        <div class="no-account" style="margin: 0 0 20px;">
                            <div class="text"><strong>Ingresa el correo electrónico con el que ingresas al
                                portal.</strong></div>
                        </div>
                        <mat-form-field appearance="outline">
                            <mat-label>Correo electrónico</mat-label>
                            <input appToLowercase formControlName="email" type="text" matInput required
                                   autocomplete="off">
                            <mat-error *ngIf="formRecovery.controls.email.hasError('required')">Campo requerido
                            </mat-error>
                            <mat-error
                                    *ngIf="!formRecovery.controls.email.hasError('required') && formRecovery.controls.email.hasError('emailFormat')">
                                Correo inválido
                            </mat-error>
                        </mat-form-field>
                        <div class="no-account">
                            <re-captcha *ngIf="formRecovery.valid" (resolved)="resolved($event)"
                                        (error)="onError($event)"></re-captcha>
                        </div>
                        <div class="no-account">
                            <div class="text" *ngIf="formRecovery.invalid"><span>Si no recuerdas tu correo electrónico es necesario que te comuniques con tu administrador.</span>
                            </div>
                            <br>
                            <p>
                                <button *ngIf="formRecovery.valid && captcha" mat-raised-button
                                        (click)="recoveryPass()"><span>Recuperar</span>
                                </button>
                            </p>
                            <p (click)="recoveryPassword = false"><span>< Regresar</span></p>
                        </div>
                    </form>
                </div>
            </div>

            <!-- PASS NO RECUPERADO-->
            <div class="content-res" *ngIf="changePass">
                Cambia tu contraseña
            </div>

            <div class="box-light-fondo" *ngIf="changePass">
                <div class="wrapper">
                    <form [formGroup]="formPass">
                        <div class="no-account" style="margin: 0 0 20px;">
                            <p><strong>Reglas:</strong><br>
                                13 caracteres mínimo<br>
                                Utiliza por lo menos una mayúscula<br>
                                Utiliza por lo menos un número<br>
                                Utiliza por lo menos un caracter especial</p>
                        </div>
                        <mat-form-field appearance="outline">
                            <mat-label>Nueva contraseña</mat-label>
                            <input formControlName="passNew" [type]="hide ? 'password' : 'text'"
                                   matInput required autocomplete="off">
                            <mat-icon matSuffix
                                      (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="formPass.controls.passNew.hasError('required')">Campo requerido
                            </mat-error>
                            <mat-error
                                    *ngIf="!formPass.controls.passNew.hasError('required') && formPass.controls.passNew.hasError('passFormat')">
                                Tu contraseña no cumple los requisitos mínimos.
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Repite tu nueva contraseña</mat-label>
                            <input formControlName="passRepit" [type]="hide ? 'password' : 'text'" matInput required
                                   autocomplete="off">
                            <mat-icon matSuffix
                                      (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="formPass.controls.passRepit.hasError('required')">Campo requerido
                            </mat-error>
                            <mat-error
                                    *ngIf="!formPass.controls.passRepit.hasError('required') && formPass.controls.passRepit.hasError('passFormat')">
                                Tu contraseña no cumple los requisitos mínimos.
                            </mat-error>
                        </mat-form-field>
                        <mat-error *ngIf="checarSiSonIguales()">
                            Las contraseñas no son iguales.
                        </mat-error>
                        <div class="actions">
                            <button [ngClass]="{'disabled':formPass.invalid}" [disabled]="formPass.invalid"
                                    class="submit-button" (click)="changePassword()">
                                <p>GUARDAR</p>
                            </button>
                        </div>
                        <div class="no-account">
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</app-template>
